import ILocation from "../types/locationType";
const israelLocation = {
    key: "כל הארץ",
    bounds:[ 34.2,29.5, 35.6, 33.3]
} as ILocation
export default israelLocation;
